import { sliderToBrushSize, brushSizeToSlider } from '../drawing.utils';
import type { DrawingStateCreator, ToolsSlice } from './types';

export const createToolsSlice: DrawingStateCreator<ToolsSlice> = (set) => ({
  tool: 'pencil',
  previousTool: null,
  brushSettings: {
    size: 7,
    opacity: 100,
    color: '#39FF14', // Neon green
    storedBrushSize: 7,
    storedEraserSize: 40,
  },
  cloneSettings: {
    source: null,
    offset: null,
    aligned: false,
  },

  setTool: (tool) =>
    set((state) => {
      const currentTool = state.tool;

      // Save current size to the appropriate stored field
      if (currentTool === 'pencil') {
        state.brushSettings.storedBrushSize = state.brushSettings.size;
      } else if (currentTool === 'eraser') {
        state.brushSettings.storedEraserSize = state.brushSettings.size;
      }

      // Load stored size for the new tool
      if (tool === 'pencil') {
        state.brushSettings.size = state.brushSettings.storedBrushSize;
      } else if (tool === 'eraser') {
        state.brushSettings.size = state.brushSettings.storedEraserSize;
      }

      state.previousTool = state.tool;
      state.tool = tool;
    }),

  toggleTool: () =>
    set((state) => {
      if (state.tool === 'pencil') {
        state.brushSettings.storedBrushSize = state.brushSettings.size;
        state.brushSettings.size = state.brushSettings.storedEraserSize;
        state.tool = 'eraser';
      } else if (state.tool === 'eraser') {
        state.brushSettings.storedEraserSize = state.brushSettings.size;
        state.brushSettings.size = state.brushSettings.storedBrushSize;
        state.tool = 'pencil';
      }
    }),

  setBrushSize: (size) =>
    set((state) => {
      state.brushSettings.size = Math.max(2, Math.min(100, size));
      state.ui.brushSliderValue = brushSizeToSlider(size);
    }),

  setBrushSliderValue: (value) =>
    set((state) => {
      state.ui.brushSliderValue = value;
      state.brushSettings.size = sliderToBrushSize(value);
    }),

  setBrushColor: (color) =>
    set((state) => {
      state.brushSettings.color = color;
    }),

  setBrushSettings: (settings) =>
    set((state) => {
      Object.assign(state.brushSettings, settings);
    }),

  setCloneSource: (point) =>
    set((state) => {
      state.cloneSettings.source = point;
      // Reset offset when setting new source - it will be calculated on first use
      state.cloneSettings.offset = null;
    }),

  clearCloneSource: () =>
    set((state) => {
      state.cloneSettings.source = null;
      state.cloneSettings.offset = null;
    }),

  toggleCloneAligned: () =>
    set((state) => {
      state.cloneSettings.aligned = !state.cloneSettings.aligned;
      if (!state.cloneSettings.aligned) {
        state.cloneSettings.offset = null;
      }
    }),

  getBrushSizeFromSlider: sliderToBrushSize,
  getSliderValueFromBrushSize: brushSizeToSlider,
});
